import React from "react";
import { Modal, Button } from "react-bootstrap";
import { t } from "../../i18n";

interface Props {
  show: boolean;
  message: string;
  onClose: () => void;
}

export const SupervisorValidationModal: React.FC<Props> = ({ show, message, onClose }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("supervisorValidation.heading")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-danger">
          <p>{message}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={onClose}
        >
          {t("supervisorValidation.ok")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
